module.exports = __webpack_public_path__ + "img/creditu-iso.71e505cc.svg";